import React from 'react';
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import { LinkText, Typography } from "../ecosystem";

const DrNameSpecialty = ({
    name,
    specialty,
    provUrl,
    screenBreakPoint,
    size = "md"
}) => {

    const isMobile = ([msgs.XS_MOBILE, msgs.SM_MOBILE, msgs.MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;

    const nameType = {
        desktop: size === "md" ? 'heading-02' : 'body-02',
        mobile: size === "md" ? 'body-02' : 'body-03',
    }

    const specialtyType = {
        desktop: size === "md" ? 'body-02' : 'body-02',
        mobile: size === "md" ? 'body-01' : 'body-01',
    }

    return (<>
        {name &&
            <LinkText
                typographyType={nameType[isMobile ? 'mobile' : 'desktop']}
                to={provUrl ? { pathname: provUrl } : ''}
                onClick={(e) => {
                    logUI("MBHWeb.UI.MyFavoriteProviders.ProviderName.Clicked", new Date(), Tools.getURLPath());
                }}
            >
                {name}
            </LinkText>
        }
        {specialty &&
            <Typography
                type={specialtyType[isMobile ? 'mobile' : 'desktop']}
                tag="div"
            >
                {specialty}
            </Typography>
        }
    </>);
}

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint,
    };
};

export default connect(mapStateToProps, null)(DrNameSpecialty);
